// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Adults-module__wrapper___YqBUC"};